import { Injectable } from '@angular/core';

/**
 * Replacement for deprecated @agm/core MapsAPILoader.
 * Since Google Maps is loaded via APP_INITIALIZER in app.module.ts,
 * this service just resolves immediately.
 */
@Injectable({
  providedIn: 'root',
})
export class MapsAPILoader {
  load(): Promise<void> {
    // Google Maps is already loaded via APP_INITIALIZER (initGoogleMapsApi)
    // Just verify it's available and resolve
    if (typeof google !== 'undefined' && google.maps) {
      return Promise.resolve();
    }

    // If not loaded yet (edge case), wait for it
    return new Promise((resolve) => {
      const checkInterval = setInterval(() => {
        if (typeof google !== 'undefined' && google.maps) {
          clearInterval(checkInterval);
          resolve();
        }
      }, 50);

      // Timeout after 10 seconds
      setTimeout(() => {
        clearInterval(checkInterval);
        console.warn('MapsAPILoader: Google Maps API not available after timeout');
        resolve();
      }, 10000);
    });
  }
}
